<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-24 09:57:36
-->
<template>
  <div class="container">
    <div class="topContainer">
      <section class="leftContent">
        <section class="header">
          <div class="title" v-if="!$route.query.check">兑现资料</div>
          <div class="information" v-if="!$route.query.check">
            <el-upload
              class="upload-demo"
              drag
              :on-success="uploadSuc"
              :file-list="fileList"
              :headers="uploadHeader"
              :disabled="$route.query.status == 3 || $route.query.check"
              :on-change="changeData"
              :limit="9"
              :on-remove="removeData"
              accept=".doc, .docx, .xls, .xlsx, .pdf, .jpg, .png"
              :action="uploadFileByContentType"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持扩展名：doc .docx .xls .xlsx .pdf .jpg .png…最多上传9个
              </div>
            </el-upload>
          </div>
        </section>
        <section
          v-if="$route.query.check"
          class="header"
          :style="{ height: $route.query.check ? '450px' : '100%' }"
        >
          <div class="title">详情</div>
          <div class="information">
            <span class="left-title">资料：</span>
            <div class="fileBox" v-if="fileList.length">
              <div
                class="fileItem"
                v-for="(item, index) in fileList"
                :key="index"
                @click="downLoadFile(item)"
              >
                <i class="el-icon-tickets"></i> {{ item.fileName || '-' }}
              </div>
            </div>
            <span v-if="fileList.length < 1 && fileListImg.length < 1"
              >暂无</span
            >
          </div>
          <div class="information service">
            <img
              v-for="(item, index) in fileListImg"
              :key="index"
              class="imgBox"
              :src="item.ossUrl"
              alt=""
              @click="onShow(item.ossUrl)"
            />
          </div>
          <div class="information">
            <span class="left-title">备注：</span
            ><span>{{ message.remark || '-' }}</span>
          </div>
        </section>
        <section class="review" v-if="!$route.query.check">
          <div>
            <el-form
              :model="message"
              ref="message"
              label-width="80px"
              label-position="left"
            >
              <el-form-item label="备注：">
                <el-input
                  style="min-width: 100px"
                  type="textarea"
                  v-model="message.remark"
                  placeholder="请输入"
                  :readonly="$route.query.status == 3 || $route.query.check"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
            <div
              class="dialog-footer"
              v-if="$route.query.status !== 3 && !$route.query.check"
            >
              <el-button @click="handleClose">返 回</el-button>
              <Debounce :time="5000" :isDebounce="3">
                <button
                  type="button"
                  class="el-button el-button--primary el-button--medium"
                  @click="submit('message')"
                >
                  <span>提 交</span>
                </button>
              </Debounce>
            </div>
          </div>
        </section>
      </section>
      <auditRecord :goodsRecord="goodsRecordList"></auditRecord>
    </div>

    <!-- <el-dialog :visible.sync="showImg" width="30%" class="showImg">
      <img width="100%" :src="exhibitImg" alt="" />
    </el-dialog> -->
    <el-image-viewer
      v-if="showImg"
      :on-close="
        () => {
          showImg = false
        }
      "
      :url-list="[exhibitImg]"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { uploadFileByContentType } from '@api/yardIntermediary/institutionalManagement'
import {
  getEntUploadInvoiceDetail,
  getInvoiceRecordList,
  submitAudit
} from '@api/yardIntermediary/invoice'
import auditRecord from './components/auditRecord'
import { getToken } from '@utils'
export default {
  components: { auditRecord, ElImageViewer },
  name: 'Live',
  data() {
    return {
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      uploadFileByContentType,
      title: '',
      dialogVisible: false,
      message: {
        remark: ''
      },
      fileListImg: [],
      process: [],
      status: '',
      showImg: false,
      exhibitImg: '',
      goodsRecordList: [], // 审核记录
      detail: {
        attachmentList: []
      },
      fileList: [], // 附件下载
      auditStatus: '',
      type: ''
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getInvoiceRecordList()
    this.auditStatus = this.$route.query.status
    if (this.auditStatus) {
      this.getProductDetail()
    }
  },
  mounted() { },
  methods: {
    // 上传成功
    uploadSuc(response) { },
    changeData(file, fileList) {
      if (file.status == 'ready') return
      this.fileList = fileList
    },
    removeData(file, fileList) {
      // console.log(fileList)
      this.fileList = fileList
    },
    getProductDetail() {
      getEntUploadInvoiceDetail({ dataYear: this.$route.query.dataYear }).then(
        res => {
          if (res.data.code === '0000') {
            const data = res.data.data
            this.message.remark = data.remark
            if (!this.$route.query.check) {
              this.fileList = JSON.parse(data.fileUrl).map(value => {
                return {
                  ext: value.ext,
                  name: value.fileName,
                  ossUrl: value.ossUrl
                }
              })
            } else {
              this.fileListImg = JSON.parse(data.fileUrl).filter(item => {
                return ['jpeg', 'jpg', 'png'].includes(item.ext)
              })
              this.fileList = JSON.parse(data.fileUrl).filter(item => {
                return !['jpeg', 'jpg', 'png'].includes(item.ext)
              })
            }
          }
        }
      )
    },
    getInvoiceRecordList() {
      getInvoiceRecordList({ dataYear: this.$route.query.dataYear }).then(
        res => {
          if (res.data.code === '0000') {
            this.goodsRecordList = res.data.data || []
            console.log(this.goodsRecordList)
          }
        }
      )
    },
    /** 打开弹性 */
    onShow(item) {
      // console.log(item)

      this.exhibitImg = item
      this.showImg = true
    },
    /** 关闭联系企业清空弹窗 */
    handleClose() {
      this.$router.push({ name: 'upload' })
    },
    submit(formName) {
      if (!this.fileList.length) {
        this.$message.warning('请上传文件')
        return
      }
      let list = []
      JSON.parse(JSON.stringify(this.fileList)).map(item => {
        if (item.response) {
          list.push(item.response.data)
        } else {
          list.push({ ext: item.ext, fileName: item.name, ossUrl: item.ossUrl })
        }
      })
      let data = {
        dataYear: this.$route.query.dataYear,
        auditRemark: null,
        remark: this.message.remark,
        fileUrlList: list
      }
      submitAudit(data).then(res => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.$router.push({ name: 'upload' })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    downLoadFile(d) {
      let url = d.ossUrl
      // pdf 预览，其他都下载
      const urlSuffixType = url.split('.')
      const urlType = urlSuffixType[urlSuffixType.length - 1]
      const openType = ['pdf'].includes(urlType.toLowerCase())
        ? '_blank'
        : '_self'
      window.open(url, openType)
    }
  }
}
</script>
<style>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss" scoped>
.showImg {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
}
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    // height: 400px;
    overflow: auto;
    padding: 30px 60px 20px;
    font-size: 16px;
    .el-textarea__inner {
      height: 100px;
    }
  }
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }
  .el-upload-list__item {
    width: 120px;
    height: 120px;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.container {
  width: 100%;
  .topContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    overflow: auto;
    & > .leftContent {
      width: 100%;
      height: calc(100% - 10px);
      background: white;
      overflow-y: scroll;
      &::-webkit-scrollbar-thumb {
        display: none;
      }
      > .header {
        background: white;
        padding-bottom: 20px;
        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 600;
          border-bottom: 1px solid #eee;
        }
        .fileBox {
          width: 100% !important;
          // display: flex;
          .fileItem {
            cursor: pointer;
            background: #f7f7f7;
            padding: 2px 5px;
            margin-bottom: 5px;
            i {
              font-size: 15px;
              color: rgb(51, 153, 255);
              margin-right: 4px;
            }
          }
        }
        & > .service {
          > div {
            width: 100%;
            display: flex;
            > div {
              > div {
                margin-bottom: 10px;
                > span {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        & > .information {
          padding: 0 24px 16px;
          margin-top: 16px;
          display: flex;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          .imgBox {
            width: 148px;
            height: 148px;
            margin-right: 20px;
            border: 1px dashed #eee;
            cursor: pointer;
          }
          .left-title {
            white-space: nowrap;
          }
          .fileBox {
            color: rgba(0, 0, 0, 0.5);
            > div {
              margin-right: 20px;
            }
          }
          #editor {
            width: 800px;
          }
          span {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
      > .footer {
        margin-top: 16px;

        > .title {
          padding: 16px 21px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
        > .block {
          width: 60%;
          margin-top: 30px;
        }
      }
      > .review {
        width: 60%;
        margin-top: 16px;
        padding: 24px 30px;
        background: white;
        /deep/ .el-textarea__inner {
          min-height: 150px !important;
        }
        .dialog-footer {
          display: flex;
          margin-left: 80px;
          // justify-content: center;
        }
      }
    }
  }
}
</style>
